<div class="login-body">
    <div class="login-panel ui-fluid">
        <div class="login-container--overlay"></div>
        <div class="ui-g login-container" style="padding-bottom: 20px;">
            <div class="login-container--content">
                <div class="ui-g-12">
                    <input type="text" autocomplete="off" class="ui-inputtext ui-corner-all ui-state-default ui-widget"
                        placeholder="First Name" [(ngModel)]="firstname">
                </div>
                <div class="ui-g-12">
                    <input type="text" autocomplete="off" class="ui-inputtext ui-corner-all ui-state-default ui-widget"
                        placeholder="Last Name" [(ngModel)]="lastname">
                </div>
                <div class="ui-g-12">
                    <input type="text" autocomplete="off" class="ui-inputtext ui-corner-all ui-state-default ui-widget"
                        placeholder="Email" [(ngModel)]="email">
                </div>
                <div class="ui-g-12">
                    <input type="password" autocomplete="off"
                        class="ui-inputtext ui-corner-all ui-state-default ui-widget" placeholder="Password"
                        [(ngModel)]="password">
                </div>

                <div class="ui-g-12">
                    <p-checkbox [(ngModel)]="agreed" binary="true" (onChange)="accepted($event)" label="I agree">
                    </p-checkbox>
                </div>

                <div class="ui-g-12 button-container">
                    <div class="button-overlay">
                        <button [disabled]="!agreed" pButton type="button" label="Create Account"
                            class="p-button-success" (click)="tryCreate()"></button>
                    </div>

                    <div class="ui-g-12">
                        <label>Already have an account? </label>
                        <a href="" [routerLink]="['/login']">Login</a>
                    </div>
                </div>
            </div>
        </div>
        <!--
      <div class="stripe"></div>
      <div class="stripe"></div>
-->
    </div>
</div>